<template>
  <el-dialog title="尖峰谷平时段" :visible.sync="dialogVisible" width="1080px" :before-close="handleClose" :close-on-click-modal="false" left>
    <div style="margin-bottom:10px;">
        <el-button size="mini" icon="el-icon-sort" type="info" @click="priceList('sortPrice')" style="background-color:#409eff;">按时段排序</el-button>
        <span>&nbsp;&nbsp;&nbsp;</span>
        <el-button size="mini" icon="el-icon-sort" type="info" @click="priceList('sortMonth')" style="background-color:#409eff;">按月份排序</el-button>
    </div>
    <DiluTable :list="tableData" :tableConfig="tableConfig">
        <el-table-column prop="stype" label="电价时段" width="100" align="left">
          <template slot-scope="scope">
            <span v-if="scope.row.stype == 'jian'">尖</span>
            <span v-if="scope.row.stype == 'feng'">峰</span>
            <span v-if="scope.row.stype == 'ping'">平</span>
            <span v-if="scope.row.stype == 'gu'">谷</span>
          </template>
        </el-table-column>
        <el-table-column prop="dayStart" label="开始日期" width="150" align="left" />
        <el-table-column prop="dayEnd" label="结束日期" width="150" align="left" />
        <el-table-column prop="timeStart" label="开始时间" width="100" align="left" />
        <el-table-column prop="timeEnd" label="结束时间" width="100" align="left" />                        
        <el-table-column prop="price" label="电价" width="100" align="left" />
        <el-table-column prop="createdAt" label="创建时间" width="150" align="left" />
        <el-table-column prop="updatedAt" label="更新时间" width="150" align="left" />
    </DiluTable>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import DiluTable from "@/components/public/dilu-table.vue";
export default {
  data() {
    return {
      tableConfig: {
          isTree: false,
          isPage: false,
      },
      tableData: [],
    };
  },
  computed: {
    ...mapState(["buttonTextColor"]),
  },
  components: {
    DiluTable
   },
  props: ["dialogVisible","project"],
  watch: {
    dialogVisible(newValue) {
      if (newValue) {
        this.priceList("sortPrice");
      }
    },
  },
  methods: {
    priceList(sortBy) {
        if (sortBy==null) {
            sortBy="sortPrice";
        }
        var params={
            project: this.project,
            sortBy: sortBy
        }
        this.request.electricityList(params).then((res) => {
            this.tableData = res.data;
        });
    },
    handleClose() {
      this.$emit("handleClose");
    }
  },
};
</script>
<style scoped>
.form-body {
  width:550px;
  display:flex;
  flex-direction:row;
  justify-content:center;
  box-sizing:border-box;
}
</style>